import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { deleteCard, getNearestCardAfterDelete } from '../../use';
import { useStorymapStore } from '../../useModule';
import { SetActiveCardIdByClick } from '../cardSelection/setActiveCardIdByClick';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, dispatch } = useStorymapStore();

export class DeleteNewCard extends Action<StorymapState> {
    public static ACTION_TYPE = 'DeleteNewCard';

    public constructor(public cardId: string) {
        super(DeleteNewCard.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: DeleteNewCard): void => {
    const neighbor = getNearestCardAfterDelete(action.cardId);

    if (neighbor != null) {
        dispatch(new SetActiveCardIdByClick(neighbor.id));
    }

    dispatch(new FlashJustDragged());

    deleteCard(action.cardId);
};

//@ts-ignore
registerReducer(DeleteNewCard.ACTION_TYPE, reducer);
